import { createBrowserRouter, Navigate, type RouteObject } from 'react-router-dom';
import { Layout } from '@/components/Layout';
import { LandingStep } from '@/components/steps/LandingStep/LandingStep';
import { WregLayout } from '@/components/webreg/WregLayout';
import { WregRoute } from '@/components/webreg/WregRoute';
import { WregExceptionRoute } from '@/components/webreg/WregExceptionRoute';
import {
  WregAgreementRoute,
  WregAllSetRoute,
  WregIntakeAboutRoute,
  WregIntakeContactRoute,
  WregIntakeMedicareRoute,
  WregIntakeRoute,
  WregLabsRoute,
  WregMonitorRoute,
  WregScreenerRoute,
  WregSwitchRoute,
  WregTracksRoute,
} from '@/components/webreg/wregScreenRoutes';
import { isWregExceptionStep } from '@/components/webreg/screens/wregExceptions';
import { RETIRED_ROUTES, WREG_ENTRY_PATH, WREG_ROUTE } from '@/components/webreg/wregRoutes';
import { WREG_ORDER, type WregStep } from '@/components/webreg/wregSteps';

const WREG_SCREEN: Partial<Record<WregStep, () => JSX.Element>> = {
  intake: WregIntakeRoute,
  'intake-contact': WregIntakeContactRoute,
  'intake-about': WregIntakeAboutRoute,
  'intake-mbi': WregIntakeMedicareRoute,
  screener: WregScreenerRoute,
  tracks: WregTracksRoute,
  agreement: WregAgreementRoute,
  switch: WregSwitchRoute,
  labs: WregLabsRoute,
  monitor: WregMonitorRoute,
  allset: WregAllSetRoute,
};

export const wregScreenElement = (step: WregStep): JSX.Element => {
  const Screen = WREG_SCREEN[step];
  if (Screen) return <Screen />;
  if (isWregExceptionStep(step)) return <WregExceptionRoute step={step} />;
  throw new Error(`wreg: step "${step}" has no route element`);
};

const wregRoutes: RouteObject[] = [
  {
    element: <WregLayout />,
    children: WREG_ORDER.map((step) => ({
      path: WREG_ROUTE[step],
      element: <WregRoute step={step}>{wregScreenElement(step)}</WregRoute>,
    })),
  },
];

const retiredRedirects: RouteObject[] = RETIRED_ROUTES.map((path) => ({
  path,
  element: <Navigate to={WREG_ENTRY_PATH} replace />,
}));

const router = createBrowserRouter([
  {
    path: WREG_ENTRY_PATH,
    element: <Layout />,
    children: [
      { index: true, element: <LandingStep /> },
      ...retiredRedirects,
      { path: '*', element: <Navigate to={WREG_ENTRY_PATH} replace /> },
    ],
  },
  ...wregRoutes,
]);

export { router };
